module.exports = __webpack_public_path__ + "img/riseup_plus_fair.f9a43b64.svg";